<template>
  <div>
    <form>
      <!-- Basic Filters -->
      <b-form-row>
        <b-form-group class="col-md-2" label="Criterio de Agrupación">
          <b-form-select 
            size="sm" 
            v-model="filters.group" 
            :options="optionsGroup">
          </b-form-select>
        </b-form-group>
        
        <b-form-group class="col-md-2" label="Criterio Fechas">
          <b-form-select 
            size="sm" 
            v-model="filters.dateCriteria" 
            :options="optionsCriteriaDates">
          </b-form-select>
        </b-form-group>

        <b-form-group class="col-md-4 float-right mt-3">
          <a href="/reviews/imports" class="btn btn-info mr-1">Importar Reseñas</a>
          <a class="btn btn-primary text-white" @click="reloadBooking">Actualizar Booking
            <img :src="logo" width="20">
          </a>
        </b-form-group>
      </b-form-row>

      <!-- Row filters -->
      <b-form-row>
        <b-form-group class="col-md-3" label="Agrupar por">
          <b-form-radio-group
            id="btn-radios-1"
            v-model="filters.timeGroup"
            :options="optionsTimeGroup"
            buttons
            name="radios-btn-default">
          </b-form-radio-group>
        </b-form-group>

        <b-form-group class="col-md-3" label="Fecha desde *" >
          <b-form-datepicker 
            locale="es" 
            :class="{'active-filter':filters.startDate}" 
            reset-button size="sm" 
            v-model="filters.startDate"/>
        </b-form-group>

        <b-form-group class="col-md-3" label="Hasta *" >
          <b-form-datepicker 
            locale="es" 
            :class="{'active-filter':filters.endDate}" 
            reset-button  
            size="sm" 
            v-model="filters.endDate"/>
        </b-form-group>

        <b-form-group class="col-lg-1" label="Viaje">
          <b-form-select
            :class="{ 'active-filter': filters.trip }"
            v-model="filters.trip"
            :options="tripOpts"/>
        </b-form-group>

        <b-form-group class="col-md-2 table-responsive">
          <br>
          <b-button 
            variant="warning" 
            v-b-toggle="'advanced-filters'" 
            class="btn mr-2" 
            id="advanced-filters">
            <md-icon icon="filter_list"/>
          </b-button>
          <b-tooltip 
            target="advanced-filters" 
            triggers="hover">
            Mostrar/Ocultar Filtros avanzados
          </b-tooltip>
          <b-button 
            variant="outline-primary" 
            type="button" 
            @click="checkform()">
            <md-icon icon="search"/>
          </b-button>
        </b-form-group>
      </b-form-row>
      <!-- End basic filters -->

      <!-- Advanced filters -->
      <b-collapse id="advanced-filters">
        <b-form-row>
          <b-form-group class="col-lg-3 mt-0" label="Calificación">
            <multiselect
              v-model="filters.stars"
              :options="starsOpts"
              group-label="group"
              group-values="options"
              group-select
              multiple
              label="text"
              track-by="value"
              placeholder="Todos"
              taggable>
              <template v-slot:clear >
                <div class="multiselect__clear" @click="filters.stars = []">
                </div>
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group class="col-lg-3" label="Canal de venta">
						<GroupedSalesChannelsSelect
							v-model="filters.salesChannels"
							placeholder="Todos"
						/>
					</b-form-group>

          <b-form-group class="col-lg-3" label="Proveedor">
            <multiselect
              v-model="filters.suppliers"
              :options="suppliersOpts"
              group-label="group"
              group-values="options"
              group-select
              multiple
              label="text"
              track-by="value"
              placeholder="Todos"
              taggable>
              <template v-slot:clear >
                <div class="multiselect__clear" @click="filters.suppliers = []">
                </div>
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group class="col-lg-6" label="Zonas">
            <multiselect 
              v-model="filters.zones"
              :options="optionsDestinations"
              group-label="group"
              group-values="options"
              group-select
              multiple
              label="text"
              track-by="value"
              placeholder="Todos"
              taggable>
                <span slot="noResult">Oops! No se encontraron resultados.</span>
                <template v-slot:clear >
                  <div class="multiselect__clear" @click="filters.zones = []"></div>
                </template>
            </multiselect>
          </b-form-group>
        </b-form-row>
      </b-collapse>
      <!-- End advanced filters -->
    </form>

    <b-row>

      <div class="col-12 text-left text-primary" v-if="filters.dateCriteria == 'service-date'">
        No se podrán listar los reviews que no cuenten con una referencia valida a un servicio.**
      </div>

      <!-- Loading -->
			<div v-if="loading" class="col-12 text-center pt-5">
				<b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
			</div>
      <!-- End Loading -->
			
			<b-col class="col-lg-7 mt-4" v-if="!loading">
				<div class="table-responsive async-tables text-center" v-if="showHtmlTable">
					<b-table
            id="spit-main-table"
            show-empty
            hover
            small
            bordered
            stacked-sm
            responsive
            :items="table.body" 
            :fields="table.header"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            selectable
            select-mode="multi"
            @row-clicked="item=>onRowSelected(item)">

              <!-- A virtual column -->
              <template #cell(index)="data">
                <div class="text-left">
                  <md-icon 
                    icon="star"
                    class="text-warning font-weight-bolder"
                    style="font-size: 12px; padding-bottom: 2px;"
                    v-if="data.item.star == true"/>
                    {{ data.item.index }}
                    <template v-if="data.rowSelected">
                      <md-icon 
                      icon="keyboard_arrow_down"
                      class="font-weight-bolder"/>
                    </template>
                    <template v-else>
                      <md-icon 
                      icon="keyboard_arrow_right"
                      class="font-weight-bolder"/>
                    </template>
                </div>
              </template>

              <!-- A virtual column -->
              <template #cell(reviews)="data">
                <div class="text-right">
                  {{ number_format(data.item.reviews,0,'.',',') }}
                </div>
              </template>

               <!-- A virtual column -->
              <template #cell(average)="data">
                <div class="text-right">
                  {{ number_format(data.item.average, 1) }}
                  <md-icon 
                    icon="star"
                    class="text-warning font-weight-bolder"
                    style="font-size: 12px; padding-bottom: 2px;"/>
                </div>
              </template>

              <template #row-details="row">
                <div class="ml-2">
                  <TableDeep :ref="'table'+row.item.index" @show-details="loadDetails($event)"></TableDeep>
                </div>
              </template>
					</b-table>
				</div>
			</b-col>
      <b-col class="col-lg-5 mt-4 sticky-div" v-if="!loading">
        <div class="border px-5 py-3">
          <b-row>
            <b-col cols="12" class="text-center pb-2">
              <h5>{{ details.title }}</h5>
              <small>{{ details.parent  }}</small>
            </b-col>
            <b-col cols="7">
              <b-row v-for="(star, index) in details.stars" v-bind:key="index">
                <b-col cols="2" class="text-center my-auto">
                  {{ star['label'] }}
                </b-col>
                <b-col>
                  <b-progress :value="star['value']" :max="details.max" show-value class="mb-3 my-auto">
                  </b-progress>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <div class="text-center">
                <h5 style="font-size: 4vw;">{{ number_format(details.average,1) }}</h5>
                <md-icon
                  v-for="(star, index) in details.stars"
                  v-bind:key="index"
                  icon="star"
                  :class="getStarColor(details.stars_round, index)"
                  style="font-size: 16px; padding-bottom: 4px;"/>

                <div class="text-muted">
                  <small>{{ number_format(details.reviews,0,'.',',') }} reseñas</small>
                </div>
              </div>
            </b-col>
          </b-row>
          <!-- Tags classifications -->
          <b-row>
            <b-col>
              <hr>
              <div class="text-center">
                <b-button variant="light" class="mr-1 mt-1" v-for="tag in details.tags" :key="tag.label">
                  {{ tag.label }} <b-badge variant="secondary">{{ tag.value }}</b-badge>
                </b-button>
              </div>
            </b-col>
          </b-row>
          <!-- End Tags classifications -->
          <!-- Comments -->
          <b-row>
            <b-col cols="12" class="my-3" v-for="review in details.comments" :key="review.client_name">
              <div class="d-flex justify-content-between">
                <strong>{{ review.client_name }}</strong>
                <div class="text-muted">
                  <small>#{{ review.service_number }}</small>
                </div>
              </div>

              <div class="d-flex justify-content-between">
                <div><small class="text-muted">{{ review.product }}</small></div>
                <div><small class="text-muted">{{ review.supplier }}</small></div>
              </div>
              <div>
                <md-icon
                  v-for="(star, index) in 5"
                  v-bind:key="star"
                  icon="star"
                  :class="getStarColor(review.stars_round, index)"
                  style="font-size: 16px;"/>

                <small class="text-muted ml-2">{{ review.review_date }}</small>
              </div>
              <small>{{ review.comment }}</small>
            </b-col>
          </b-row>
          <!-- End Comments -->
        </div>
      </b-col>
		</b-row>

  </div>
</template>
<script>
  import moment from 'moment'
  import Multiselect from 'vue-multiselect';
  import TableDeep from './Table.vue';
  import api from "../../../../api.js";
  import logo from "../../../../assets/bookingcom_icon.svg";
  import GroupedSalesChannelsSelect from "../../../helpers/GroupedSalesChannelsSelect";

  export default {
    name: "reviews",
    components:{ Multiselect, TableDeep, GroupedSalesChannelsSelect },
    data() {

      let start = moment().startOf('month').format("YYYY-MM-DD");
      let end   = moment().format("YYYY-MM-DD");

      return {
        logo,
        allowBooking: true, 
        loading: false,
        codeReport: 'reviews',
        showHtmlTable: true,
        filters: {
          dateCriteria: 'service-date',
          startDate: start,
          endDate: end,
          timeGroup: 'per-day',
          salesChannels: [],
          suppliers: [],
          zones: [],
          trip: 0,
          group: 'accounts',
          parent: null,
          row_selected: null,
          stars: []
        },
        sortBy: 'index',
        sortDesc: true,
        table: {
          header: [
            {
              key: 'index',
              label: 'Periodo',
              sortable: true
            },
            {
              key: 'reviews',
              label: 'Reseñas',
              sortable: true
            },
            {
              key: 'average',
              label: 'Score',
              sortable: true,
              variant: 'info'
            }
          ],
          body: []
        },
        items: [],
        selected:'per-week',
        optionsGroup:[
          { text: 'Cuenta', value: 'accounts' },
          { text: 'Proveedor', value: 'suppliers' },
          { text: 'Destino', value: 'destinations' }
        ],
        optionsTimeGroup:[
          { text: 'Año', value: 'per-year' },
          { text: 'Mes', value: 'per-month' },
          { text: 'Semana', value: 'per-week' },
          { text: 'Dia', value: 'per-day' },
        ],
        optionsDestinations: [],
        optionsCriteriaDates:[
          { text: 'Por fecha de servicio', value: 'service-date'},
          { text: 'Por fecha de reseña', value: 'review-date' },
        ],
        details: {
          title: "",
          stars: [
            {"label": 5, "value" : 0},
            {"label": 4, "value" : 0},
            {"label": 3, "value" : 0},
            {"label": 2, "value" : 0},
            {"label": 1, "value" : 0}
          ],
          max: 0,
          average: 0.0,
          parent: '',
          tags: [],
          comments: [],
          platform: "",
          destination: "",
          supplier: ""
        }
      }
    },
    methods:{
      onRowSelected(item) {
        this.$set(item, '_showDetails', !item._showDetails)
        this.$nextTick(() => {
          if (item._showDetails) {
            const childComponent = this.$refs['table'+item.index];
            if (childComponent) {
              this.filters.row_selected = item.index
              this.filters.parent       = item.row_type
              this.filters.period       = item.period
              childComponent.loadTable(this.filters, item.index);
            } else {
              console.error('Table Child component reference is undefined.');
            }  
          }
        })
      },
      number_format (number, decimals, dec_point, thousands_sep) {
        // Strip all characters but numerical ones.
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
        prec  = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep   = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec   = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s     = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
        
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
          s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }

        if ((s[1] || '').length < prec) {
          s[1] = s[1] || '';
          s[1] += new Array(prec - s[1].length + 1).join('0');
        }

        return s.join(dec);
      },
      checkform() {
        let errors = [];
        if (this.filters.startDate === "" || this.filters.endDate === "") {
          errors.push("Fecha inicio y fecha fin son requeridos");
        }

        if (this.filters.dateCriteria === "") {
          errors.push("Criterio fechas es requerido");
        }
        if (errors.length === 0) {
          this.search();
        } else {
          this.$root.showAlert(errors[0],{variant:'warning'});
        }
      },
      search() {
        this.loading        = true
        this.showHtmlTable  = false;
        this.table.body     = []
        this.filters.parent = null
        this.filters.row_selected = null;
        this.reloadDetails()
        api(this)
          .get(`/reports/${this.codeReport}`, {
            params: {
              filters: this.filters
            }
          })
          .then(res => {

            this.showHtmlTable = true;
            const data = res.data.body;

            let body = []
            for (const group in data) {
              body.push(data[group])
            }
            
            this.table.body = body
          })
          .catch(error => {
            this.$root.handleRequestError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      loadDetails(data) {

        this.reloadDetails()

        let stars = []
        for (const property in data.item.stars) {
          stars.push({"label": property, "value": data.item.stars[property]})
        }
        
        this.details.stars       = stars.sort((a,b) => parseInt(b.label) - parseInt(a.label))
        this.details.max         = data.item.reviews
        this.details.title       = data.item.index
        this.details.average     = data.item.average
        this.details.reviews     = data.item.reviews
        this.details.stars_round = data.item.stars_round
        this.details.parent      = data.item.parent_name
        this.details.platform    = data.item.platform
        this.details.supplier    = data.item.supplier
        this.details.destination = data.item.destination

        let tags = []
        Object.keys(data.item.tags).forEach(key => {
          tags.push({"label": key, "value" : data.item.tags[key]})
        });

        this.details.tags = tags

        this.getComments(data.item)
      },
      reloadDetails() {

        this.details.stars = [
          {"label": 5, "value" : 0},
          {"label": 4, "value" : 0},
          {"label": 3, "value" : 0},
          {"label": 2, "value" : 0},
          {"label": 1, "value" : 0}
        ]

        this.details.max         = 0
        this.details.title       = ''
        this.details.average     = 0
        this.details.reviews     = 0
        this.details.stars_round = 0
        this.details.parent      = ''
        this.details.tags        = []
        this.details.comments    = []
      },
      getComments(item) {
        let filters = Object.assign({}, this.filters)
        filters.comments   = true
        filters.parent_row = item.parent_row
        filters.row_type   = item.row_type
        filters.index      = item.index
        api(this)
          .get(`/reports/${this.codeReport}`, {
            params: {
              filters: filters
            }
          })
          .then(res => {
            const data = res.data.body;
            this.details.comments = data;
          })
          .catch(error => {
            this.$root.handleRequestError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      getStarColor(stars_round, index) {
        let color = (stars_round >= index + 1) ?'text-warning' : 'text-secondary';
        return 'font-weight-bolder '+color
      },
      getDestinationsOpts() {
        let destinations = []
        api(this)
          .get(`/reviews/destinations`)
          .then(res => {
            
            const data = res.data;
            data.forEach(element => {
              destinations.push({value: element, text: element})
            });

            this.optionsDestinations = [
              {
                group: "SELECT ALL",
                options: destinations
              }
            ]
          })
          .catch(error => {
            this.$root.handleRequestError(error);
          })
      },
      reloadBooking() {
        if (this.allowBooking == true) {
          this.loading = true;
          this.allowBooking = false;

          api(this)
            .post(`/booking/surveys`)
            .then(res => {
              const response = res.data;
              console.log(response)
              this.search()
            })
            .catch(error => {
              this.$root.handleRequestError(error);
            })
            .finally(() => {
              this.loading = false;
              this.allowBooking = true;
            });
        }
      }
    },
    mounted(){
      this.$root.auxVars.loadResourcesOpts({
        vm: this, 
        resourceNames: [
          'salesChannelsOpts',
          'masterZonedAreasOpts',
          'suppliersOpts',
          'transportServiceStatusOpts'
        ]
      })

      this.getDestinationsOpts()
    },
    computed:{
      filtersClean(){
				let zonesIds     = this.filters.zones.map((item)=>item.value);
				let supplierIds  = this.filters.supplier.map((item)=>item.value)
				let statusIds    = this.filters.status.map((item)=>item.value)
				let cpFilters    = {...this.filters};

				cpFilters.zones    = zonesIds;
				cpFilters.supplier = supplierIds;
				cpFilters.status   = statusIds;

				return cpFilters;
			},
      channelOpts(){
        let aux= [...this.$root.auxVars.salesChannelsOpts.map((sc) => ({
          value: sc.id,
          text: sc.code,
        }))];
        return aux;
      },
      zonedAreasGroupedOpts(){
				let grouped = [];
				this.$root.auxVars.masterZonedAreasOpts.forEach((ele)=>{
					let item = {
						zonedArea:ele.name,
						zones:ele.zones.map((aux)=>({value:aux.id,text:aux.name,zonedAreaName:ele.name}))
					};
					grouped.push(item)
				})
        return grouped
			},
      suppliersOpts(){
        return [
          {
            group: "SELECT ALL",
            options: this.$root.auxVars.suppliersOpts.map((sp) => ({
              value: sp.id,
              text: sp.code
            }))
          }
        ];
      },
      tripOpts() {
        let aux = [...this.$root.auxVars.tripOpts];
        aux.unshift({ value: 0, text: "Todos" });
        return aux;
      },
      starsOpts() {
        return [
          {
            group: "SELECT ALL",
            options: [
              {value:1, text: "1 Estrella"},
              {value:2, text: "2 Estrellas"},
              {value:3, text: "3 Estrellas"},
              {value:4, text: "4 Estrellas"},
              {value:5, text: "5 Estrellas"}
            ]
          }
        ]
      }
    },
  }
</script>